import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Button, Select, AutoComplete, Checkbox, DatePicker, notification, Modal } from "antd";
import Loader from "./components/loader";
import AutoSearchBox from "./components/autoSearchBox";
import { functionService } from "../../lib/functions";
import * as Styled from "./styled";
import Styles from "./styles/callerForm.module.scss";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import moment from "moment";
import close from '../../images/close.svg';
import { useNavigate } from "react-router-dom";
import logo from '../../images/coffeelogo.svg';
import Sidemenu from "../../components/sidemenu";

dayjs.extend(utc);

var passYear = [
    { value: moment(moment().subtract(18, 'year').calendar()).format('YYYY') + ' or earlier', key: moment(moment().subtract(18, 'year').calendar()).format('YYYY') + '-' }
];
for (let i = Number(moment(moment().subtract(17, 'year').calendar()).format('YYYY')); i < Number(moment(moment().add(1, 'year').calendar()).format('YYYY')); i++) {
    passYear.push({ value: String(i), key: String(i) });
}
passYear.push({ value: moment(moment().add(1, 'year').calendar()).format('YYYY') + ' or later', key: moment(moment().add(1, 'year').calendar()).format('YYYY') + '+' });

const cvsourceList = [
    { key: 'INTERNALDB', value: 'Internal DB' },
    { key: 'NAUKRI', value: "Naukri" },
    { key: "LINKEDIN CENTRAL", value: "Linkedin Central" },
    { key: "LINKEDIN RECRUITER", value: "Linkedin Recruiter" },
    { key: "OTHERS", value: "Others" }
];

const highestQualificationList = [
    { key: 'DIPLOMA_ENGINEERING', value: 'Diploma in Engineering' },
    { key: 'ADVANCED_DIPLOMA', value: 'Advanced Diploma' },
    { key: 'POST_DIPLOMA_CERT', value: 'Post Diploma Certification' },
    { key: 'BTECH_BE', value: 'B.Tech / B.E.' },
    { key: 'BCA', value: 'BCA (Bachelor of Computer Applications)' },
    { key: 'BSC_CS', value: 'BSc – Computer Science' },
    { key: 'BSC_IT', value: 'BSc – IT' },
    { key: 'BSC_SE', value: 'BSc – Software Engineering' },
    { key: 'BSC_DS_AI_ML', value: 'BSc – Data Science / AI / ML' },
    { key: 'BSC_ELEC', value: 'BSc – Electronics / Electrical' },
    { key: 'BCOM', value: 'B.Com' },
    { key: 'BBA', value: 'BBA' },
    { key: 'BA', value: 'BA (Any Specialization)' },
    { key: 'MTECH_ME', value: 'M.Tech / M.E.' },
    { key: 'MCA', value: 'MCA (Master of Computer Applications)' },
    { key: 'MSC_CS', value: 'MSc – Computer Science' },
    { key: 'MSC_IT', value: 'MSc – IT' },
    { key: 'MSC_DS_AI_ML', value: 'MSc – Data Science / AI / ML' },
    { key: 'MSC_CYBER', value: 'MSc – Cybersecurity' },
    { key: 'MBA', value: 'MBA (IT / Systems / Analytics / General)' },
    { key: 'PGDM', value: 'PGDM (IT / Analytics)' },
    { key: 'CA', value: 'CA (Chartered Accountant)' },
    { key: 'CFA', value: 'CFA (Chartered Financial Analyst)' },
    { key: 'CS', value: 'CS (Company Secretary)' },
    { key: 'CMA', value: 'CMA / ICWA (Cost & Management Accountant)' },
    { key: 'PHD_CS', value: 'PhD – Computer Science' },
    { key: 'PHD_IT_AI', value: 'PhD – IT / AI / ML / Data Science' },
    { key: 'PHD_ENGINEERING', value: 'PhD – Engineering (Any Specialization)' },
    { key: 'MS_INTL', value: 'MS (Master of Science – International)' },
    { key: 'BS_INTL', value: 'BS (Bachelor of Science – International)' },
    { key: 'BACHELORS_INTL_NON_ENG', value: "Bachelor's Degree (Non-Engineering – International)" },
    { key: 'MASTERS_INTL_NON_ENG', value: "Master's Degree (Non-Engineering – International)" },
];

const currentDate = new Date().toISOString();

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);

const T = {
    pink: "#FF2C91", blue: "#1B49EA", navy: "#0d2172",
    border: "#c9c9c9", bg: "#f7f8fc", white: "#fff",
    text: "#1E2228", muted: "#939599", red: "#f04638", green: "#22c55e",
    radius: 10, inputH: 54,
};

const S = {
    input: { width: "100%", fontSize: 14, border: `1px solid ${T.border}`, borderRadius: 8, padding: "0 14px", height: T.inputH, boxSizing: "border-box", outline: "none", background: T.white, color: T.text, fontFamily: "inherit" },
    inputLocked: { width: "100%", fontSize: 14, border: `1px solid ${T.border}`, borderRadius: 8, padding: "0 14px", height: T.inputH, boxSizing: "border-box", outline: "none", background: "#f0f2f5", color: T.muted, fontFamily: "inherit", cursor: "not-allowed" },
    ctcWrap: { display: "flex", alignItems: "center", border: `1px solid ${T.border}`, borderRadius: 8, height: T.inputH, paddingLeft: 14, background: T.white, boxSizing: "border-box", overflow: "hidden" },
    ctcInput: { border: "none", outline: "none", fontSize: 14, flex: 1, background: "transparent", minWidth: 0 },
    ctcUnit: { borderLeft: `1px solid ${T.border}`, padding: "0 12px", fontSize: 13, color: T.muted, whiteSpace: "nowrap", height: "100%", display: "flex", alignItems: "center" },
    select: { width: "100%", height: T.inputH },
    row: { display: "flex", gap: 20, flexWrap: "wrap" },
    col2: { flex: "1 1 calc(50% - 10px)", minWidth: 200, marginBottom: 20 },
    col3: { flex: "1 1 calc(33.33% - 14px)", minWidth: 180, marginBottom: 20 },
    col4: { flex: "1 1 calc(25% - 15px)", minWidth: 160, marginBottom: 20 },
    card: { background: T.white, border: "1px solid #efeff0", boxShadow: "0 4px 24px rgba(29,37,45,0.05)", borderRadius: 14, padding: "28px 36px", marginTop: 20 },
    cardTitle: { color: T.pink, fontSize: 18, fontWeight: 700, marginBottom: 20, marginTop: 0 },
    label: { fontWeight: 600, fontSize: 14, marginBottom: 6, display: "block", color: T.text },
    radioWrap: { display: "flex", gap: 24, alignItems: "center", flexWrap: "wrap" },
    radioLabel: { display: "flex", alignItems: "center", gap: 8, fontSize: 14, cursor: "pointer" },
    textarea: { width: "100%", minHeight: 90, border: `1px solid ${T.border}`, borderRadius: 8, padding: 12, fontSize: 14, resize: "vertical", boxSizing: "border-box", fontFamily: "inherit", outline: "none" },
};

/* ─── SkillPair ─────────────────────────────────────────────────────────────── */
const SkillPair = ({
    skillKey, expKey, label, required, disabled,
    data, filterList, onSkillSearch, skillUpdate, expUpdate, totalWorkExp
}) => {
    const isUUIDStr = (val) =>
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(String(val || ""));

    const [displayText, setDisplayText] = React.useState("");
    const resolvedRef = React.useRef(false);
    const userActiveRef = React.useRef(false);

    React.useEffect(() => {
        if (!filterList || filterList.length === 0) return;
        if (userActiveRef.current) return;

        const val = data[skillKey];
        if (!val) {
            setDisplayText("");
            resolvedRef.current = false;
            return;
        }

        if (isUUIDStr(val)) {
            const match = filterList.find(i => i.id === val);
            if (match) {
                setDisplayText(match.name);
                resolvedRef.current = true;
            } else {
                setDisplayText(val);
                resolvedRef.current = true;
            }
        } else {
            setDisplayText(val);
            resolvedRef.current = true;
        }
    }, [filterList, skillKey, data[skillKey]]);

    const prevValRef = React.useRef(data[skillKey]);
    React.useEffect(() => {
        const val = data[skillKey];
        const prevVal = prevValRef.current;
        prevValRef.current = val;
        if (!val && prevVal && !userActiveRef.current) {
            setDisplayText("");
            resolvedRef.current = false;
        }
    }, [data[skillKey]]);

    const handleChange = (val) => {
        if (disabled) return;
        userActiveRef.current = true;
        resolvedRef.current = true;
        setDisplayText(val ?? "");
        if (!val || val.trim() === "") {
            skillUpdate(skillKey, null);
        } else {
            skillUpdate(skillKey, val);
        }
        onSkillSearch(val || "");
    };

    const handleSelect = (optionValue, option) => {
        if (disabled) return;
        userActiveRef.current = false;
        resolvedRef.current = true;
        setDisplayText(option.label);
        skillUpdate(skillKey, optionValue);
    };

    const handleClear = () => {
        if (disabled) return;
        userActiveRef.current = false;
        resolvedRef.current = false;
        setDisplayText("");
        skillUpdate(skillKey, null);
    };

    const handleFocus = () => { userActiveRef.current = true; };
    const handleBlur = () => { userActiveRef.current = false; };

    return (
        <div style={{ ...S.col3, opacity: disabled ? 0.4 : 1, transition: "opacity 0.2s" }}>
            <p style={S.label}>
                {label}{required && <span style={{ color: T.red }}> *</span>}
            </p>
            <div style={{
                display: "flex", height: T.inputH,
                border: `1px solid ${T.border}`, borderRadius: 8,
                overflow: "hidden",
                background: disabled ? "#f5f5f5" : T.white,
            }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <AutoComplete
                        style={{ width: "100%", height: T.inputH }}
                        bordered={false}
                        placeholder={disabled ? "Fill previous skill first" : "Select or type skill"}
                        value={displayText}
                        disabled={disabled}
                        options={filterList?.map(item => ({ value: item.id, label: item.name }))}
                        onChange={handleChange}
                        onSelect={handleSelect}
                        onClear={handleClear}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        filterOption={(input, option) =>
                            option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        dropdownStyle={{ zIndex: 9999 }}
                        allowClear
                    />
                </div>
                <div style={{ width: 1, background: T.border, flexShrink: 0 }} />
                <input
                    style={{
                        width: 60, height: "auto", flexShrink: 0,
                        border: "none", outline: "none",
                        fontSize: 13, textAlign: "center",
                        background: data[skillKey] ? T.white : "#f5f5f5",
                        color: data[skillKey] ? T.text : "#bbb",
                        cursor: data[skillKey] ? "text" : "not-allowed",
                        fontFamily: "inherit",
                    }}
                    type="text"
                    placeholder="Yrs"
                    value={data[expKey] || ""}
                    readOnly={!data[skillKey]}
                    onChange={e => {
                        if (!data[skillKey]) return;

                        const v = e.target.value;

                        if (/^\d*\.?\d{0,1}$/.test(v) || v === "") {
                            expUpdate(expKey, v === "" ? null : v);
                        }
                    }}
                />
            </div>
        </div>
    );
};

/* ─── Component ───────────────────────────────────────────────────────────── */
const CallerForm = ({ queryParams }) => {
    // ── Change 4: read navigate state for locked pre-fill ──
    const location = useLocation();
    const navState = location.state || {};
    const isLocked = navState.locked === true;

    const [demandData, setDemandData] = useState({ role_title: '' });
    const [compName, setCompName] = useState(isLocked ? navState.company_name || '' : '');
    const [roleName, setRoleName] = useState(isLocked ? navState.role_title || '' : '');

    const [checkClicked, setCheckClicked] = useState(false);
    const [fetchStatus, setFetchStatus] = useState(null);

    const [resumeProcessing, setResumeProcessing] = useState(false);
    const [checkingCandidate, setCheckingCandidate] = useState(false);
    const [resumeDetailsFetched, setResumeDetailsFetched] = useState(false);

    // ── Submission confirmation popup state ──
    const [confirmOpen, setConfirmOpen] = useState(false);

    const resumeParsingRef = useRef(false);   // guards against overlapping parse calls
    const parsedCvUrlRef = useRef(null);      // the cv_url already parsed, so we don't re-parse it
    const lastCheckedEmailRef = useRef(null); // email that fetchStatus currently reflects

    const [candidateData, setCandidateData] = useState(() => {
        const d = {
            first_name: "", last_name: null, email: "", primary_no: "",
            cv_source: null, year_of_pass: null, cv_url: null,
            total_work_exp: null, relevant_experience: null,
            current_company: "", current_role: "", current_ctc: null,
            variables: null, stock_opt: null, expected_ctc: null,
            candidate_location: null, candidate_prefered_location: [],
            remote_job: null, notice_period: null, currently_serving: null,
            last_working_day: null, available_from: null, negotiable: null,
            buy_out_available: null, shortest_notice_period: null,
            offer_in_hand: null, joining_date_of_offer: null, offered_ctc: null,
            primary_skills: [], other_skills: [], demand_id: "",
            skills_exp: [],
            alternate_no: null, unique_id: null,
            date_of_birth: null,
            highest_qualification: null,
            immediate_joining: false,
            resume_text: null,
        };
        if (queryParams && Object.keys(queryParams).length !== 0) {
            for (const [key, value] of Object.entries(queryParams)) {
                if (key.includes("[]")) d[key.replace("[]", "")] = queryParams[key];
                else d[key] = queryParams[key];
            }
        }
        return d;
    });

    const [rolesAvailable, setRoleAvailable] = useState([]);
    const [candidateDataAvailable, setCandidateDataAvailable] = useState(true);
    const [companylist, setCompanyList] = useState([]);
    const [locationOption, setLocationOption] = useState([]);
    const [filterLocationOption, setFilterLocationOption] = useState([]);
    const [filterCurrentLocationOption, setFilterCurrentLocation] = useState([]);
    const [skillOptions, setSkillOptions] = useState([]);
    const [primarySkillsOptions, setPrimarySkillsOptions] = useState([]);
    const [otherSkillsOptions, setOtherSkillsOptions] = useState([]);
    const [filterList, setFilter] = useState([]);
    const [otherSkillCandidateOptions, setOtherSkillCandidateOptions] = useState([]);
    const [roleQuestions, setRoleQuestions] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [resumeName, setResumeName] = useState(null);
    const [miscFileName, setMiscFileName] = useState(null);
    const [companyFilter, setCompanyFilter] = useState([]);
    const [emailError, setEmailError] = useState("");

    const [callDetails, setCallDetails] = useState({
        remarks: "",
        fitment_score: null,
        send_assessment_link: null, assessment_schedule_datetime: null,
    });

    const [data, setData] = useState(() => {
        const d = {
            skill1: null, skill2: null, skill3: null, skill4: null, skill5: null,
            exp1: null, exp2: null, exp3: null, exp4: null, exp5: null,
            otherSkills: [], arr1: [], arr2: [],
            response1: null, response2: null, response3: null, response4: null, response5: null,
            role_responses: [],
        };
        if (queryParams && Object.keys(queryParams).length !== 0) {
            for (const [key, value] of Object.entries(queryParams)) {
                if (key.includes("[]")) d[key.replace("[]", "")] = queryParams[key];
                else d[key] = queryParams[key];
            }
        }
        return d;
    });

    /* ─── API helpers ─────────────────────────────────────────────────────── */
    const getCompanyName = async () => {
        const userId = localStorage.getItem('userId');
        const r = await functionService.get(`demand/personalized-companies-list/${userId}`);
        if (r?.response?.data?.data?.length > 0) { setCompanyList(r.response.data.data); setCompanyFilter(r.response.data.data); }
    };

    const getJobRoles = async () => {
        if (demandData.company_name) {
            const userId = localStorage.getItem('userId');

            const r = await functionService.post('demand/company-roles', {
                recruiter_id: userId,
                company_name: demandData.company_name
            });

            setRoleAvailable(r?.response?.data?.data);
        }
    };

    const fetchDemandData = async (companyName, jobrole) => {
        if (!companyName || !jobrole) return;
        const rec_id = localStorage.getItem("userId");
        const r = await functionService.post('demand/get-demand-role-details', { company_name: companyName, role_title: jobrole, recruiter_id: rec_id });
        const d0 = r?.response?.data?.data?.[0];
        setPrimarySkillsOptions((d0?.primary_skills || []).map(id => skillOptions.find(i => i.id === id)?.name).filter(Boolean));
        setOtherSkillsOptions((d0?.other_skills || []).map(id => skillOptions.find(i => i.id === id)?.name).filter(Boolean));

        const rq = {}; let qi = 1;
        Object.entries(d0?.role_specific_requirement || {}).forEach(([, v]) => {
            if (v !== null && v !== undefined && v !== '') { rq[`question${qi}`] = { question: v, answer: '' }; qi++; }
        });
        setRoleQuestions(Object.keys(rq).length > 0 ? rq : null);
        setDemandData(prev => ({ ...prev, ...(r?.response?.data?.data?.[0] || {}) }));
    };

    const checkCandidateDetails = async () => {
        setResumeDetailsFetched(false);
        setCheckClicked(true);
        setCheckingCandidate(true);
        const existingCvUrl = candidateData.cv_url;
        lastCheckedEmailRef.current = candidateData.email;

        const r = await functionService.post('demand/check-candidate-details', { email: candidateData?.email });
        setCheckingCandidate(false);

        const rows = r?.response?.data?.data || [];
        setCandidateDataAvailable(rows.length > 0);
        if (rows.length === 0) {
            setFetchStatus('not_found');
            setCandidateData(prev => ({
                ...prev,
                first_name: "", last_name: "", primary_no: "", cv_source: null, year_of_pass: null,
                total_work_exp: null, current_company: "", current_role: "",
                current_ctc: null, variables: "", stock_opt: "", expected_ctc: null,
                candidate_location: null, candidate_prefered_location: [],
                remote_job: null, notice_period: null, currently_serving: null,
                available_from: null, negotiable: null, buy_out_available: null,
                shortest_notice_period: null, offer_in_hand: null, offered_ctc: null,
                primary_skills: [], other_skills: [], demand_id: "", skills_exp: [],
                alternate_no: null, date_of_birth: null, highest_qualification: null,
                immediate_joining: false,
                misc_file_url: null,
                cv_url: existingCvUrl || null, // preserved -- was wiped before; see Scenario C
            }));
            setResumeName(prevName => existingCvUrl ? prevName : "");
            setData(prev => ({
                ...prev,
                skill1: null, skill2: null, skill3: null, skill4: null, skill5: null,
                exp1: null, exp2: null, exp3: null, exp4: null, exp5: null,
                otherSkills: [],
            }));

            // Scenario C: resume was uploaded before Fetch was clicked -- now that
            // we know the candidate is new, parse it. Guarded so we never re-parse
            // the same file twice.
            // if (existingCvUrl && parsedCvUrlRef.current !== existingCvUrl) {
            //     parseResumeAndAutofill(existingCvUrl);
            // }
        } else {
            setFetchStatus('found');
            setCandidateData(prev => ({
                ...prev,
                ...rows[0],
                immediate_joining: rows[0]?.immediate_joining || false,
                cv_url: prev.cv_url || rows[0]?.cv_url,
            }));
            const url = rows[0]?.cv_url;
            if (url) setResumeName(decodeURIComponent(url.split('/').pop()));

            const ps = rows[0]?.primary_skills || [];
            setData(prev => ({
                ...prev,
                skill1: ps[0] || null,
                skill2: ps[1] || null,
                skill3: ps[2] || null,
                skill4: ps[3] || null,
                skill5: ps[4] || null,
            }));

            const se = rows[0]?.skills_exp || [];
            setData(prev => ({
                ...prev,
                exp1: se[0] || null,
                exp2: se[1] || null,
                exp3: se[2] || null,
                exp4: se[3] || null,
                exp5: se[4] || null,
            }));

            const os = rows[0]?.other_skills || [];
            const osNames = os.map(id => {
                const match = filterList.find(i => i.id === id);
                return match ? match.name : id;
            }).filter(Boolean);
            setData(prev => ({ ...prev, otherSkills: osNames }));
        }
    };

    const uploadHandler = async (event) => {
        if (!event.target.files?.length) return;
        const f = event.target.files[0];
        if (f.size >= 2 * 1000 * 1000) { notification.error({ message: "File size exceeded", description: "Max 2MB allowed" }); return; }
        if (!f.name.toLowerCase().match(/\.pdf$/)) { notification.error({ message: "Unsupported format", description: "PDF files only" }); return; }
        const res = await functionService.uploadFile(f);
        if (res.status) {
            const uploadedUrl = res.response.data.location;
            setCandidateData(prev => ({ ...prev, cv_url: uploadedUrl }));
            setResumeName(f.name);
            // Upload only -- resume extraction is now manual, triggered by
            // the "Fetch Resume Details" button, never automatically here.
            setResumeDetailsFetched(false);
            parsedCvUrlRef.current = null;
        }
    };

    const resolveQualificationKey = (text) => {
        if (!text) return null;
        const norm = text.toLowerCase().trim();
        const exact = highestQualificationList.find(item => item.value.toLowerCase() === norm);
        if (exact) return exact.key;
        const partial = highestQualificationList.find(item =>
            norm.includes(item.value.toLowerCase()) || item.value.toLowerCase().includes(norm)
        );
        return partial ? partial.key : null;
    };

    const parseResumeAndAutofill = async (cvUrl) => {
        if (!cvUrl) return;
        if (resumeParsingRef.current) return; // duplicate-request guard
        resumeParsingRef.current = true;
        parsedCvUrlRef.current = cvUrl;
        setResumeProcessing(true);

        const res = await functionService.parseResume({ cv_url: cvUrl });

        setResumeProcessing(false);
        resumeParsingRef.current = false;

        if (!res.status) {
            const errMsg =
                res?.error?.response?.data?.meta?.message ||
                res?.error?.response?.data?.error ||
                "Could not process the resume. Please fill in the details manually.";
            notification.error({ message: "Resume Processing Failed", description: errMsg });
            return;
        }

        const extracted = res?.response?.data?.data;
        if (!extracted) {
            notification.error({ message: "Resume Processing Failed", description: "No data returned from resume parsing." });
            return;
        }

        // Fields intentionally excluded per spec §12: current_ctc, expected_ctc,
        // notice_period, currently_serving, offer_in_hand, offered_ctc,
        // demand_id, cv_source, cv_url.
        setCandidateData(prev => ({
            ...prev,
            first_name: extracted.first_name || prev.first_name,
            last_name: extracted.last_name ?? prev.last_name,
            primary_no: extracted.primary_no || prev.primary_no,
            alternate_no: extracted.alternate_no ?? prev.alternate_no,
            current_company: extracted.current_company || prev.current_company,
            current_role: extracted.current_role || prev.current_role,
            total_work_exp: extracted.total_work_exp ?? prev.total_work_exp,
            date_of_birth: extracted.date_of_birth || prev.date_of_birth,
            highest_qualification: resolveQualificationKey(extracted.highest_qualification) || prev.highest_qualification,
            candidate_location: extracted.candidate_location || prev.candidate_location,
            year_of_pass: extracted.year_of_pass ? String(extracted.year_of_pass) : prev.year_of_pass,
            primary_skills: extracted.primary_skills?.length ? extracted.primary_skills : prev.primary_skills,
            skills_exp: extracted.skills_exp?.length ? extracted.skills_exp : prev.skills_exp,
            other_skills: extracted.other_skills?.length ? extracted.other_skills : prev.other_skills,
            candidate_prefered_location: extracted.candidate_prefered_location?.length
                ? extracted.candidate_prefered_location
                : prev.candidate_prefered_location,
            // Pass through the text already extracted during this same
            // request, so add-candidate-details never re-extracts it.
            resume_text: extracted.resume_text || prev.resume_text,
        }));

        // Mirror into the skillN/expN/otherSkills UI state, same as the
        // "found" branch does for DB rows.
        const ps = extracted.primary_skills || [];
        const se = extracted.skills_exp || [];
        setData(prev => ({
            ...prev,
            skill1: ps[0] || null,
            skill2: ps[1] || null,
            skill3: ps[2] || null,
            skill4: ps[3] || null,
            skill5: ps[4] || null,
            exp1: se[0] != null ? String(se[0]) : null,
            exp2: se[1] != null ? String(se[1]) : null,
            exp3: se[2] != null ? String(se[2]) : null,
            exp4: se[3] != null ? String(se[3]) : null,
            exp5: se[4] != null ? String(se[4]) : null,
            otherSkills: extracted.other_skills || [],
        }));

        setResumeDetailsFetched(true);

        notification.success({
            message: "Resume Processed",
            description: "Candidate details have been auto-filled from the resume. Please review before submitting.",
        });
    };

    const miscUploadHandler = async (event) => {
        if (!event.target.files?.length) return;
        const f = event.target.files[0];
        if (f.size >= 2 * 1000 * 1000) { notification.error({ message: "File size exceeded", description: "Max 2MB allowed" }); return; }
        if (!f.name.toLowerCase().match(/\.pdf$/)) { notification.error({ message: "Unsupported format", description: "PDF files only" }); return; }
        const res = await functionService.uploadFile(f);
        if (res.status) { setCandidateData(prev => ({ ...prev, misc_file_url: res.response.data.location })); setMiscFileName(f.name); }
    };

    const apiCall = async (path, data, type) => {
        const res = type === "post" ? await functionService.post(path, data) : await functionService.get(path + data);
        const d = path === "recruiter/locations?name=" ? res?.response?.data?.data?.location : res?.response?.data?.data?.skills;
        if (res.status && d) return d.map((item, i) => ({ key: i, value: item.name, ...item }));
        return [];
    };

    const handleAutoCompleteSearch = async (fieldName, val) => {
        if (fieldName === "otherSkills_all") setOtherSkillCandidateOptions(await apiCall("recruiter/skills?name=", val, "get"));
    };
    function debounce(func, wait) { let t; return function (...args) { if (t) clearTimeout(t); t = setTimeout(() => { t = null; func.apply(this, args); }, wait); }; }
    const debouncedSearch = useCallback(debounce(handleAutoCompleteSearch, 500), []);

    const navigate = useNavigate();

    const resolveQualificationLabel = (key) => {
        const found = highestQualificationList.find(item => item.key === key);
        return found ? found.value : key;
    };

    const isUUID = (val) =>
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val);

    const resolveSkillId = async (skillVal) => {
        if (!skillVal) return null;
        if (isUUID(skillVal)) return skillVal;
        const match = filterList?.find(s => s.name?.toLowerCase() === String(skillVal).toLowerCase());
        if (match) return match.id;
        try {
            const r = await functionService.post("demand/add-skill", { name: skillVal });
            console.log("add-skill response:", JSON.stringify(r));
            const newId = Array.isArray(r?.response?.data?.data)
                ? r?.response?.data?.data?.[0]?.id
                : r?.response?.data?.data?.id || r?.response?.data?.id;
            if (!newId) throw new Error(`Failed to register skill: ${skillVal}`);
            return newId;
        } catch (e) {
            notification.error({ message: "Skill Error", description: e.message });
            return null;
        }
    };

    /**
     * Runs all field validation (unchanged from the original submitData logic).
     * If everything checks out, instead of submitting immediately it opens the
     * "Are the details correct?" confirmation popup. The actual submission only
     * happens once the user presses "Yes" in that popup (see doSubmit below).
     */
    const handleSubmitClick = () => {
        let err = "";
        if (!roleName || !demandData.role_title) err = 'Please fill demand data details';
        else if (!candidateData.email) err = 'Please fill the email';
        else if (!isValidEmail(candidateData.email)) err = 'Please enter a valid email address';
        else if (!candidateData.first_name) err = 'Please fill the First name';
        else if (!candidateData.primary_no) err = 'Please fill the primary number';
        else if (!candidateData.cv_url) err = 'Please upload the cv';
        else if (!candidateData.current_company) err = 'Please fill the current company';
        else if (!candidateData.total_work_exp) err = 'Please fill the total work experience';
        else if (!candidateData.relevant_experience) err = 'Please fill the relevant experience';
        else if (parseFloat(candidateData.relevant_experience) > parseFloat(candidateData.total_work_exp)) err = 'Relevant experience cannot exceed total work experience';
        else if (
            candidateData.skills_exp?.some(
                (exp) =>
                    exp !== null &&
                    exp !== "" &&
                    candidateData.total_work_exp !== null &&
                    candidateData.total_work_exp !== "" &&
                    parseFloat(exp) > parseFloat(candidateData.total_work_exp)
            )
        ) {
            err = "Skill experience cannot exceed total work experience";
        }
        else if (!candidateData.primary_skills?.[0]) err = 'Please fill the skill 1';
        else if (!candidateData.skills_exp?.[0]) err = 'Please fill the experience for skill 1';
        else if (!candidateData.current_ctc) err = 'Please fill the current CTC';
        else if (!candidateData.expected_ctc) err = 'Please fill the expected CTC';
        else if (!candidateData.candidate_location) err = 'Please fill the current location';
        else if (candidateData.candidate_prefered_location?.length === 0) err = "Please enter preferred job location";
        else if (candidateData.currently_serving === null || candidateData.currently_serving === undefined) err = 'Please select notice period status';
        else if (candidateData.currently_serving === true && !candidateData.last_working_day) err = 'Please fill the last working day';
        else if (candidateData.currently_serving === true && !candidateData.available_from) err = 'Please fill the date available from';
        else if (candidateData.currently_serving === false && !candidateData.immediate_joining && !candidateData.notice_period) err = 'Please fill the notice period';
        else if (candidateData.currently_serving === false && candidateData.negotiable && !candidateData.shortest_notice_period) err = 'Please fill the shortest notice period';
        else if (
            candidateData.currently_serving === false &&
            candidateData.negotiable &&
            candidateData.shortest_notice_period &&
            candidateData.notice_period &&
            parseInt(candidateData.shortest_notice_period) >= parseInt(candidateData.notice_period)
        ) err = 'Shortest notice period must be less than the notice period';
        else if (candidateData.offer_in_hand === null || candidateData.offer_in_hand === undefined) err = 'Please select if offer in hand';
        else if (candidateData.offer_in_hand && !candidateData.offered_ctc) err = 'Please fill the offered CTC';
        else if (candidateData.offer_in_hand && !candidateData.joining_date_of_offer) err = "Please enter joining date of offer";
        else if (callDetails.fitment_score === null || callDetails.fitment_score === undefined || callDetails.fitment_score === "") err = 'Please fill the fitment score';
        else if (callDetails.fitment_score < 0 || callDetails.fitment_score > 100) err = 'Fitment score must be between 0 and 100';
        else if (!callDetails.assessment_schedule_datetime) err = 'Please fill the assessment schedule date & time';
        else if (!candidateData.cv_source) err = 'Please fill the cv source';
        else {
            [1, 2, 3, 4, 5].forEach(n => {
                if (roleQuestions?.[`question${n}`] !== null && roleQuestions?.[`question${n}`]?.answer === '') err = 'Please answer all the Role Specific Requirements';
            });
        }

        setError(err);

        if (err) {
            navigate(`/submission-form`, { replace: true });
            return;
        }

        // All required fields look good -- ask the recruiter to double-check
        // before the data actually gets submitted.
        setConfirmOpen(true);
    };

    /**
     * Performs the actual submission (API calls). Only invoked after the
     * recruiter confirms "Yes" on the popup triggered by handleSubmitClick.
     */
    const doSubmit = async () => {
        setCandidateData(prev => ({ ...prev, demand_id: demandData.id }));
        setLoading(true);

        const userToken = localStorage.getItem("userId");

        const resolvedPrimarySkills = (
            await Promise.all(candidateData.primary_skills.map(resolveSkillId))
        ).filter(Boolean);

        const resolvedOtherSkills = (
            await Promise.all((candidateData.other_skills || []).map(resolveSkillId))
        ).filter(Boolean);

        // const res = await functionService.post("demand/add-candidate-details", {
        //     first_name: (candidateData.first_name || "").trim(), last_name: (candidateData.last_name || "").trim(),
        //     email: candidateData.email, primary_no: candidateData.primary_no,
        //     cv_source: candidateData.cv_source, year_of_pass: candidateData.year_of_pass,
        //     cv_url: candidateData.cv_url, misc_file_url: candidateData.misc_file_url || null, total_work_exp: candidateData.total_work_exp || null,
        //     relevant_experience: candidateData.relevant_experience || null,
        //     current_company: candidateData.current_company, current_role: candidateData.current_role,
        //     current_ctc: candidateData.current_ctc || null, variables: candidateData.variables || null,
        //     stock_opt: candidateData.stock_opt || "", expected_ctc: candidateData.expected_ctc || null,
        //     candidate_location: candidateData.candidate_location,
        //     candidate_prefered_location: candidateData.candidate_prefered_location,
        //     notice_period: candidateData.currently_serving === false
        //         ? (candidateData.immediate_joining ? "Immediate" : (candidateData.notice_period ? `${candidateData.notice_period} days` : null))
        //         : null,
        //     currently_serving: candidateData.currently_serving || null,
        //     notice_status: candidateData.notice_status,
        //     last_working_day: candidateData.currently_serving ? candidateData.last_working_day : null,
        //     available_from: candidateData.currently_serving ? candidateData.available_from : null,
        //     negotiable: candidateData.negotiable || null, buy_out_available: candidateData.buy_out_available || null,
        //     shortest_notice_period: candidateData.negotiable ? candidateData.shortest_notice_period : null,
        //     offer_in_hand: candidateData.offer_in_hand || null,
        //     offered_ctc: candidateData.offer_in_hand ? candidateData.offered_ctc : null,
        //     joining_date_of_offer: candidateData.offer_in_hand ? candidateData.joining_date_of_offer : null,
        //     primary_skills: resolvedPrimarySkills,
        //     other_skills: resolvedOtherSkills,
        //     demand_id: demandData.id,
        //     skills_exp: candidateData.skills_exp || [], jobType: demandData.job_type,
        //     companyName: compName, roleTitle: roleName, jobLocationType: demandData.location_type,
        //     jobLocation: demandData?.location || [], maxCtc: demandData.max_ctc,
        //     assessmentLink: demandData.assessment_link || null,
        //     wantAssessment: callDetails?.send_assessment_link || null,
        //     alternate_no: candidateData?.alternate_no || null, unique_id: userToken,
        //     test_link: demandData.assessment_link || null, caller_id: localStorage.getItem("userEmail"),
        //     date_of_birth: candidateData.date_of_birth || null,
        //     highest_qualification: candidateData.highest_qualification
        //         ? resolveQualificationLabel(candidateData.highest_qualification)
        //         : null,
        // });
        
                const res = await functionService.post("demand/add-candidate-details", {
            first_name: (candidateData.first_name || "").trim(), last_name: (candidateData.last_name || "").trim(),
            email: candidateData.email, primary_no: candidateData.primary_no,
            cv_source: candidateData.cv_source, year_of_pass: candidateData.year_of_pass,
            cv_url: candidateData.cv_url, misc_file_url: candidateData.misc_file_url || null,
            resume_text: candidateData.resume_text || null,
            total_work_exp: candidateData.total_work_exp || null,
            relevant_experience: candidateData.relevant_experience || null,
            current_company: candidateData.current_company, current_role: candidateData.current_role,
            current_ctc: candidateData.current_ctc || null, variables: candidateData.variables || null,
            stock_opt: candidateData.stock_opt || "", expected_ctc: candidateData.expected_ctc || null,
            candidate_location: candidateData.candidate_location,
            candidate_prefered_location: candidateData.candidate_prefered_location,
            notice_period: candidateData.currently_serving === false
                ? (candidateData.immediate_joining ? "Immediate" : (candidateData.notice_period ? `${candidateData.notice_period} days` : null))
                : null,
            currently_serving: candidateData.currently_serving || null,
            notice_status: candidateData.notice_status,
            last_working_day: candidateData.currently_serving ? candidateData.last_working_day : null,
            available_from: candidateData.currently_serving ? candidateData.available_from : null,
            negotiable: candidateData.negotiable || null, buy_out_available: candidateData.buy_out_available || null,
            shortest_notice_period: candidateData.negotiable ? candidateData.shortest_notice_period : null,
            offer_in_hand: candidateData.offer_in_hand || null,
            offered_ctc: candidateData.offer_in_hand ? candidateData.offered_ctc : null,
            joining_date_of_offer: candidateData.offer_in_hand ? candidateData.joining_date_of_offer : null,
            primary_skills: resolvedPrimarySkills,
            other_skills: resolvedOtherSkills,
            demand_id: demandData.id,
            skills_exp: candidateData.skills_exp || [], jobType: demandData.job_type,
            companyName: compName, roleTitle: roleName, jobLocationType: demandData.location_type,
            jobLocation: demandData?.location || [], maxCtc: demandData.max_ctc,
            assessmentLink: demandData.assessment_link || null,
            wantAssessment: callDetails?.send_assessment_link || null,
            alternate_no: candidateData?.alternate_no || null, unique_id: userToken,
            test_link: demandData.assessment_link || null, caller_id: localStorage.getItem("userEmail"),
            date_of_birth: candidateData.date_of_birth || null,
            highest_qualification: candidateData.highest_qualification
                ? resolveQualificationLabel(candidateData.highest_qualification)
                : null,
        });
        
        setLoading(false);
        if (res?.status === true && res?.response?.data?.meta?.code === 200) {
            const res1 = await functionService.post("demand/add-call-details", {
                candidate_id: res?.response?.data?.data?.[0]?.id, call_date: currentDate,
                remarks: callDetails.remarks || "",
                demand_id: demandData.id,
                fitment_score: callDetails.fitment_score !== null && callDetails.fitment_score !== undefined ? `${callDetails.fitment_score}%` : null,
                assessment_schedule_datetime: callDetails.assessment_schedule_datetime || null,
                send_assessment_link: callDetails.send_assessment_link ?? null,
                role_specific_requirement_ans: roleQuestions || null,
                recruiter_id: localStorage.getItem('userId'),
                recruiter_caller_name: localStorage.getItem('user_name'),
            });
            if (res1?.status === true && res1?.response?.data?.meta?.code === 200) { navigate(`/confirm-call`, { replace: true }); }
            else setError(res1?.response?.data?.error?.message || "Something went wrong");
        } else {
            const errorData = res?.error?.response?.data || res?.response?.data;
            if (errorData?.error === "duplicate_candidate") {
                setError(errorData?.meta?.message || "Candidate already exists for this demand");
            } else {
                navigate(`/submission-form`, { replace: true });
                setError(errorData?.meta?.message || errorData?.error || "Something went wrong");
            }
        }
        setLoading(false);
    };

    const getLocationList = async () => {
        const res = await functionService.get("recruiter/locations?name=");
        const arr = (res?.response?.data?.data?.location || []).map(i => ({ key: i.name, value: i.name }));
        setFilterLocationOption(arr); setLocationOption(arr); setFilterCurrentLocation(arr);
    };

    const getSkillsList = async () => {
        const res = await functionService.get(`recruiter/skills?name=`);
        const raw = res?.response?.data?.data?.skills || [];
        const mapped = raw.map(s => ({
            ...s,
            id: s.id ?? s.value ?? s.name,
            name: s.name,
        }));
        setSkillOptions(mapped);
        setFilter(mapped);
    };

    const onSkillSearch = e => {
        if (!e) { setFilter(filterList); return; }
        setSkillOptions(filterList.filter(i => i.name.toLowerCase().includes(e.toLowerCase())));
    };

    const onCompanySearch = e => setCompanyFilter(companylist.filter(i => i.name?.toLowerCase().includes(e.toLowerCase())));

    const buildPrimarySkills = upd => ['skill1', 'skill2', 'skill3', 'skill4', 'skill5'].map(k => upd[k]).filter(Boolean);
    const buildSkillsExp = upd => ['exp1', 'exp2', 'exp3', 'exp4', 'exp5'].map(k => upd[k]).filter(Boolean);

    const skillUpdate = (skillKey, e) => {
        if (e) {
            const toName = val => {
                if (!val) return "";
                const match = filterList?.find(s => s.id === val);
                return (match?.name ?? String(val)).toLowerCase();
            };
            const others = ['skill1', 'skill2', 'skill3', 'skill4', 'skill5'].filter(k => k !== skillKey);
            if (others.some(k => data[k] && toName(data[k]) === toName(e))) {
                setErrorMessage('Please check, selected skills must be unique');
                return;
            }
            if ((data.otherSkills || []).some(n => toName(n) === toName(e))) {
                setErrorMessage('Please check, selected skills must be unique');
                return;
            }
        }
        const updated = { ...data, [skillKey]: e };
        setData(updated);
        setErrorMessage('');
        setCandidateData(prev => ({ ...prev, primary_skills: buildPrimarySkills(updated) }));
    };

    const expUpdate = (expKey, e) => {
        const updated = { ...data, [expKey]: e };
        setData(updated);
        setCandidateData(prev => ({ ...prev, skills_exp: buildSkillsExp(updated) }));
    };

    const otherSkillsUpdate = loc => {
        if (['skill1', 'skill2', 'skill3', 'skill4', 'skill5'].some(k => !data[k])) {
            setErrorMessage('Please fill all 5 skills before adding Other Skills'); return;
        }
        const current = loc?.[loc.length - 1];
        if (current) {
            const toName = val => {
                const match = filterList?.find(s => s.id === val);
                return (match?.name ?? String(val)).toLowerCase();
            };
            if (['skill1', 'skill2', 'skill3', 'skill4', 'skill5'].some(k => data[k] && toName(data[k]) === current.toLowerCase())) {
                setErrorMessage('Skills must be unique'); return;
            }
        }
        setData({ ...data, otherSkills: loc });
        const otherIds = loc.map(n => {
            const match = filterList?.find(i => i.name?.toLowerCase() === n?.toLowerCase());
            return match ? match.id : n;
        }).filter(Boolean);
        setCandidateData(prev => ({ ...prev, other_skills: otherIds, otherSkills: loc }));
        setError(""); setErrorMessage("");
    };

    const responseUpdate = (qKey, dKey, val) => {
        setData(prev => ({ ...prev, [dKey]: val }));
        if (roleQuestions?.[qKey]) roleQuestions[qKey].answer = val;
    };

    // ── Change 4: when locked, auto-load demand data once skills list is ready ──
    useEffect(() => {
        getCompanyName(); getLocationList(); getSkillsList();
    }, []);

    useEffect(() => {
        if (demandData.company_name) getJobRoles();
    }, [demandData.company_name, demandData.role_title]);

    // Auto-fetch demand details when navigating with locked state
    useEffect(() => {
        if (isLocked && navState.company_name && navState.role_title && skillOptions.length > 0) {
            setDemandData(prev => ({
                ...prev,
                company_name: navState.company_name,
                role_title: navState.role_title,
            }));
            fetchDemandData(navState.company_name, navState.role_title);
        }
    }, [isLocked, skillOptions.length]);

    const Label = ({ children, required }) => (
        <p style={S.label}>{children}{required && <span style={{ color: T.red }}> *</span>}</p>
    );

    const formatCtc = (val) => {
        if (val === "" || val === null || val === undefined) return "";
        const num = parseFloat(val);
        if (isNaN(num)) return val;
        return Math.round(num * 10) / 10;
    };

    const handleCtcChange = (field, rawVal) => {
        if (/^\d*\.?\d{0,1}$/.test(rawVal) || rawVal === "") {
            setCandidateData(prev => ({ ...prev, [field]: rawVal === "" ? null : rawVal }));
        }
    };

    const isVariableCtcValid = () => {
        if (!candidateData.variables || !candidateData.current_ctc) return true;
        return parseFloat(candidateData.variables) < parseFloat(candidateData.current_ctc);
    };

    /* ─── Render ──────────────────────────────────────────────────────────── */
    return (
        <Styled.MainContainer>
            <div style={{ position: "sticky", top: 0, height: "100vh", flexShrink: 0, zIndex: 100 }}>
                <Sidemenu />
            </div>

            <Styled.ContentWrapDiv>
                {loading && <Loader loaderOpen={true} loaderText="Submitting..." />}
                {resumeProcessing && <Loader loaderOpen={true} loaderText="Processing resume — extracting details..." />}
                {checkingCandidate && <Loader loaderOpen={true} loaderText="Checking candidate details..." />}
                <div style={{ backgroundColor: T.navy, padding: "18px 36px", display: "flex", alignItems: "center" }}>
                    <img src={logo} alt="" height={36} />
                </div>

                <div style={{ padding: "24px 36px 8px", background: T.bg, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
                    <div>
                        <p style={{ fontWeight: 700, fontSize: 26, marginBottom: 4, color: T.text }}>
                            Hey {localStorage.getItem("user_name")},
                        </p>
                        <p style={{ fontSize: 14, color: T.muted, margin: 0 }}>
                            Add and update candidate data as per your ongoing call.
                        </p>
                    </div>
                    <input
                        type="text" readOnly
                        value={new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata", hour: "numeric", minute: "numeric", hour12: true, day: "numeric", month: "short", year: "numeric" })}
                        style={{ ...S.input, width: 240, color: T.muted, cursor: "default", fontSize: 13 }}
                    />
                </div>

                <div style={{ padding: "0 36px 48px" }}>

                    {/* ════ DEMAND ROLES ════ */}
                    <div style={S.card}>
                        <p style={S.cardTitle}>Demand Details</p>
                        <div style={S.row}>
                            <div style={S.col2}>
                                <Label required>Account Name</Label>
                                {/* ── Change 4: locked → read-only input; unlocked → Select ── */}
                                {isLocked ? (
                                    <input
                                        style={S.inputLocked}
                                        value={navState.company_name || ""}
                                        readOnly
                                        tabIndex={-1}
                                    />
                                ) : (
                                    <Select style={S.select} placeholder="Select company"
                                        onChange={e => { setCompName(e); setDemandData(prev => ({ ...prev, company_name: e })); }}>
                                        {companyFilter?.map(item => <Select.Option key={item.company_name} value={item.company_name}>{item.company_name}</Select.Option>)}
                                    </Select>
                                )}
                            </div>
                            <div style={S.col2}>
                                <Label required>Role</Label>
                                {/* ── Change 4: locked → read-only input; unlocked → Select ── */}
                                {isLocked ? (
                                    <input
                                        style={S.inputLocked}
                                        value={navState.role_title || ""}
                                        readOnly
                                        tabIndex={-1}
                                    />
                                ) : (
                                    <Select style={S.select} placeholder="Select role" disabled={!demandData?.company_name}
                                        onChange={async e => { setRoleName(e); setDemandData(prev => ({ ...prev, role_title: e })); await fetchDemandData(demandData?.company_name || compName, e); }}>
                                        {rolesAvailable?.map(item => <Select.Option key={item.role_title} value={item.role_title}>{item.role_title}</Select.Option>)}
                                    </Select>
                                )}
                            </div>
                        </div>

                        {(demandData?.max_ctc || demandData?.job_type) && (
                            <div style={{ marginTop: 12, padding: "20px", background: T.bg, borderRadius: 10 }}>
                                <p style={{ margin: "0 0 10px 0", fontWeight: 700, fontSize: 14, color: T.text }}>Job Role Details</p>
                                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 32px" }}>
                                    {demandData?.max_ctc && <span style={{ fontSize: 13 }}><b>CTC:</b> Upto {demandData.max_ctc} LPA</span>}
                                    {demandData?.job_type && <span style={{ fontSize: 13 }}><b>Type:</b> {demandData.job_type.charAt(0).toUpperCase() + demandData.job_type.slice(1).toLowerCase()}</span>}
                                    {demandData?.location_type && (
                                        <span style={{ fontSize: 13 }}>
                                            <b>Location:</b> {demandData.location_type}
                                            {demandData?.location ? ` — ${Array.isArray(demandData.location) ? demandData.location.join(", ") : demandData.location.replace(/[{}"]/g, "").split(",").join(", ")}` : ""}
                                        </span>
                                    )}
                                    {(demandData?.min_yrs || demandData?.max_yrs) && (
                                        <span style={{ fontSize: 13 }}><b>Experience:</b> {Number(demandData.min_yrs).toFixed(1)} - {Number(demandData.max_yrs).toFixed(1)} Years</span>
                                    )}
                                </div>
                                {(primarySkillsOptions.length > 0 || otherSkillsOptions.length > 0) && (
                                    <p style={{ fontSize: 13, marginTop: 8, marginBottom: 0 }}>
                                        <b>Skills:</b> {[...primarySkillsOptions, ...otherSkillsOptions].join(', ')}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ════ CANDIDATE DETAILS ════ */}
                    <div style={S.card}>
                        <p style={S.cardTitle}>Candidate Details</p>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 20,
                                flexWrap: "nowrap",
                            }}
                        >
                            <div style={{ flex: 1, minWidth: 0, marginBottom: 20 }}>
                                <Label required>Primary Email Address</Label>
                                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                    <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
                                        <input
                                            style={{ ...S.input, borderColor: emailError ? T.red : T.border }}
                                            type="email"
                                            value={candidateData.email}
                                            onChange={e => {
                                                const trimmed = e.target.value.replace(/\s/g, "");
                                                setCandidateData(prev => ({ ...prev, email: trimmed }));
                                                if (trimmed && !isValidEmail(trimmed)) setEmailError("Please enter a valid email address");
                                                else setEmailError("");

                                                if (fetchStatus !== null && trimmed !== lastCheckedEmailRef.current) {
                                                    setFetchStatus(null);
                                                    setCandidateDataAvailable(true);
                                                    setCheckClicked(false);
                                                    setResumeDetailsFetched(false);
                                                    parsedCvUrlRef.current = null;
                                                }
                                            }}
                                            onBlur={e => {
                                                const trimmed = e.target.value.trim().replace(/\s/g, "");
                                                setCandidateData(prev => ({ ...prev, email: trimmed }));
                                                if (trimmed && !isValidEmail(trimmed)) setEmailError("Please enter a valid email address");
                                                else setEmailError("");
                                            }}
                                            placeholder="Type candidate's email & click Check"
                                        />
                                        {emailError && <span style={{ color: T.red, fontSize: 12, marginTop: 4 }}>{emailError}</span>}
                                    </div>

                                    <button
                                        onClick={checkCandidateDetails}
                                        disabled={!candidateData.email || !!emailError || checkingCandidate || fetchStatus !== null}
                                        style={{
                                            height: T.inputH, padding: "0 24px",
                                            background: (!candidateData.email || emailError || checkingCandidate || fetchStatus !== null) ? "#a0aec0" : T.blue,
                                            color: "#fff", fontWeight: 700, fontSize: 14, border: "none",
                                            borderRadius: 8,
                                            cursor: (!candidateData.email || emailError || checkingCandidate || fetchStatus !== null) ? "not-allowed" : "pointer",
                                            whiteSpace: "nowrap",
                                        }}>
                                        {checkingCandidate ? "Checking..." : "Check"}
                                    </button>
                                </div>
                                {fetchStatus === 'not_found' && (
                                    <p style={{ color: T.red, fontSize: 13, marginTop: 6 }}>
                                        No existing record found — please fill in the details below.
                                    </p>
                                )}
                                {fetchStatus === 'found' && (
                                    <p style={{ color: T.green, fontSize: 13, marginTop: 6, fontWeight: 600 }}>
                                        ✓ Record fetched successfully — details have been pre-filled below.
                                    </p>
                                )}
                            </div>

                            {/* CV UPLOAD SECTION */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Label required>CV Upload</Label>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        {resumeName ? (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    gap: 10,
                                                    height: T.inputH,
                                                    padding: "0 14px",
                                                    background: "#f0f4ff",
                                                    borderRadius: 8,
                                                    width: "100%",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        color: T.blue,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {resumeName}
                                                </span>

                                                <img
                                                    style={{
                                                        cursor: "pointer",
                                                        flexShrink: 0,
                                                    }}
                                                    onClick={() => {
                                                        setResumeName(null);
                                                        parsedCvUrlRef.current = null;
                                                        setResumeDetailsFetched(false);

                                                        setCandidateData(prev => ({
                                                            ...prev,
                                                            cv_url: null,
                                                            resume_text: null,
                                                        }));
                                                    }}
                                                    width={12}
                                                    height={12}
                                                    src={close}
                                                    alt="remove"
                                                />
                                            </div>
                                        ) : (
                                            <label
                                                htmlFor="upload"
                                                style={{
                                                    border: `2px dashed ${T.border}`,
                                                    borderRadius: 10,
                                                    padding: "4px 16px",
                                                    background: "#f8faff",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    cursor: "pointer",
                                                    gap: 20,
                                                    width: "100%",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <input
                                                    id="upload"
                                                    hidden
                                                    type="file"
                                                    accept=".pdf"
                                                    onChange={uploadHandler}
                                                />

                                                <div>
                                                    <p
                                                        style={{
                                                            fontWeight: 600,
                                                            fontSize: 13,
                                                            margin: "0 0 3px",
                                                            color: T.text,
                                                        }}
                                                    >
                                                        Upload Resume
                                                    </p>

                                                    <span
                                                        style={{
                                                            fontSize: 12,
                                                            color: T.muted,
                                                        }}
                                                    >
                                                        PDF only · Max 2MB
                                                    </span>
                                                </div>

                                                <img alt="" src="./upload.svg" />
                                            </label>
                                        )}
                                    </div>

                                    {fetchStatus === "not_found" && candidateData?.cv_url && (
                                        <button
                                            onClick={() => parseResumeAndAutofill(candidateData.cv_url)}
                                            disabled={
                                                resumeProcessing ||
                                                parsedCvUrlRef.current === candidateData.cv_url
                                            }
                                            style={{
                                                height: T.inputH,
                                                padding: "0 24px",
                                                background:
                                                    resumeProcessing ||
                                                        parsedCvUrlRef.current === candidateData.cv_url
                                                        ? "#a0aec0"
                                                        : T.blue,
                                                color: "#fff",
                                                fontWeight: 700,
                                                fontSize: 14,
                                                border: "none",
                                                borderRadius: 8,
                                                cursor:
                                                    resumeProcessing ||
                                                        parsedCvUrlRef.current === candidateData.cv_url
                                                        ? "not-allowed"
                                                        : "pointer",
                                                whiteSpace: "nowrap",
                                                flexShrink: 0,
                                            }}
                                        >
                                            {resumeProcessing
                                                ? "Processing..."
                                                : parsedCvUrlRef.current === candidateData.cv_url
                                                    ? "Details Fetched"
                                                    : "Fetch Resume Details"}
                                        </button>
                                    )}
                                </div>

                                {resumeDetailsFetched && (
                                    <p
                                        style={{
                                            color: T.blue,
                                            fontSize: 12,
                                            marginTop: 6,
                                        }}
                                    >
                                        ⚠️ Please double-check all fetched details before submitting.
                                    </p>
                                )}
                            </div>
                        </div>



                        <div style={{ opacity: checkClicked ? 1 : 0.5, pointerEvents: checkClicked ? "auto" : "none", transition: "opacity 0.2s" }}>
                            <div style={S.row}>
                                <div style={S.col2}><Label required>First Name</Label><input style={S.input} value={candidateData?.first_name || ""} onChange={e => setCandidateData(prev => ({ ...prev, first_name: e.target.value.replace(/^\s+/, '') }))} placeholder="First name" /></div>
                                <div style={S.col2}><Label>Last Name</Label><input style={S.input} value={candidateData?.last_name || ""} onChange={e => setCandidateData(prev => ({ ...prev, last_name: e.target.value.replace(/^\s+/, '') }))} placeholder="Last name" /></div>
                                <div style={S.col2}><Label required>Primary Contact No.</Label><input style={S.input} type="text" value={candidateData?.primary_no || ""} onChange={e => { if (/^\d{0,10}$/.test(e.target.value)) setCandidateData(prev => ({ ...prev, primary_no: e.target.value })); }} placeholder="10-digit mobile number" /></div>
                                <div style={S.col2}><Label>Alternate Contact No.</Label><input style={S.input} type="text" value={candidateData?.alternate_no || ""} onChange={e => { if (/^\d{0,10}$/.test(e.target.value)) setCandidateData(prev => ({ ...prev, alternate_no: e.target.value })); }} placeholder="Alternate number" /></div>
                                <div style={S.col2}>
                                    <Label>Date of Birth</Label>
                                    <DatePicker
                                        style={{ width: "100%", height: T.inputH }}
                                        format={["DD-MM-YYYY", "DD/MM/YYYY", "DD-MM-YY", "DD/MM/YY", "DDMMYYYY"]}
                                        placeholder="DD-MM-YYYY, DD/MM/YYYY, or DDMMYYYY"
                                        allowClear
                                        value={candidateData.date_of_birth ? dayjs(candidateData.date_of_birth) : null}
                                        onChange={(date, dateString) => {
                                            if (!dateString || dateString.trim() === '') {
                                                setCandidateData(prev => ({ ...prev, date_of_birth: null }));
                                            } else {
                                                const formats = ["DD-MM-YYYY", "DD/MM/YYYY", "DD-MM-YY", "DD/MM/YY", "DDMMYYYY"];
                                                let parsedDate = null;
                                                for (const fmt of formats) {
                                                    parsedDate = dayjs(dateString, fmt, true);
                                                    if (parsedDate.isValid()) break;
                                                }
                                                if (parsedDate && parsedDate.isValid()) {
                                                    setCandidateData(prev => ({ ...prev, date_of_birth: parsedDate.utc().format() }));
                                                }
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const dateString = e.target.value;
                                            if (dateString && dateString.trim() !== '') {
                                                const formats = ["DD-MM-YYYY", "DD/MM/YYYY", "DD-MM-YY", "DD/MM/YY", "DDMMYYYY"];
                                                let parsedDate = null;
                                                for (const fmt of formats) {
                                                    parsedDate = dayjs(dateString, fmt, true);
                                                    if (parsedDate.isValid()) break;
                                                }
                                                if (parsedDate && parsedDate.isValid()) {
                                                    setCandidateData(prev => ({ ...prev, date_of_birth: parsedDate.utc().format() }));
                                                }
                                            }
                                        }}
                                    />
                                </div>
                                <div style={S.col2}>
                                    <Label>Highest Qualification</Label>
                                    <Select style={S.select} showSearch placeholder="Select qualification" value={candidateData?.highest_qualification || undefined} onChange={e => setCandidateData(prev => ({ ...prev, highest_qualification: e }))} optionFilterProp="children">
                                        {highestQualificationList.map(item => <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)}
                                    </Select>
                                </div>
                                <div style={S.col2}>
                                    <Label>Year of Passing Out</Label>
                                    <Select style={S.select} showSearch placeholder="Select year" value={candidateData?.year_of_pass} onChange={e => setCandidateData(prev => ({ ...prev, year_of_pass: e }))} optionFilterProp="children">
                                        {passYear.map(item => <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)}
                                    </Select>

                                </div>
                            </div>

                            <div style={{ display: "flex", gap: 230, flexWrap: "wrap", marginTop: 4 }}>


                                <div>
                                    <Label>Miscellaneous Files</Label>
                                    {miscFileName ? (
                                        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "#f0f4ff", borderRadius: 8, width: "fit-content" }}>
                                            <span style={{ fontSize: 14, fontWeight: 600, color: T.blue }}>{miscFileName}</span>
                                            <img style={{ cursor: "pointer" }} onClick={() => { setMiscFileName(null); setCandidateData(prev => ({ ...prev, misc_file_url: null })); }} width={12} height={12} src={close} alt="remove" />
                                        </div>
                                    ) : (
                                        <label htmlFor="misc-upload" style={{ border: `2px dashed ${T.border}`, borderRadius: 10, padding: "16px 24px", background: "#f8faff", display: "inline-flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", gap: 20, minWidth: 300 }}>
                                            <input id="misc-upload" hidden type="file" accept=".pdf" onChange={miscUploadHandler} />
                                            <div>
                                                <p style={{ fontWeight: 600, fontSize: 13, margin: "0 0 3px", color: T.text }}>Upload Misc. File</p>
                                                <span style={{ fontSize: 12, color: T.muted }}>PDF only · Max 2MB</span>
                                            </div>
                                            <img alt="" src="./upload.svg" />
                                        </label>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ════ PROFESSIONAL EXPERIENCE ════ */}
                    <div style={{ ...S.card, opacity: checkClicked ? 1 : 0.5, pointerEvents: checkClicked ? "auto" : "none", transition: "opacity 0.2s" }}>
                        <p style={S.cardTitle}>Professional Experience</p>
                        <div style={S.row}>
                            <div style={S.col2}><Label required>Current Company</Label><input style={S.input} value={candidateData.current_company || ""} onChange={e => setCandidateData(prev => ({ ...prev, current_company: e.target.value }))} placeholder="Company name" /></div>
                            <div style={S.col2}><Label>Current Role</Label><input style={S.input} value={candidateData.current_role || ""} onChange={e => setCandidateData(prev => ({ ...prev, current_role: e.target.value }))} placeholder="Designation" /></div>
                            <div style={S.col2}><Label required>Total Work Exp.</Label><input style={S.input} type="text" value={candidateData?.total_work_exp || ""} onChange={e => { const v = e.target.value; if (/^\d*\.?\d{0,1}$/.test(v) || v === "") setCandidateData(prev => ({ ...prev, total_work_exp: v === "" ? null : v })); }} placeholder="e.g. 3.5" /></div>
                            <div style={S.col2}>
                                <Label required>Rel Work Exp.</Label>
                                <input
                                    style={{
                                        ...S.input,
                                        borderColor: (candidateData.relevant_experience && candidateData.total_work_exp && parseFloat(candidateData.relevant_experience) > parseFloat(candidateData.total_work_exp)) ? T.red : T.border,
                                    }}
                                    type="text"
                                    value={candidateData?.relevant_experience || ""}
                                    onChange={e => { const v = e.target.value; if (/^\d*\.?\d{0,1}$/.test(v) || v === "") setCandidateData(prev => ({ ...prev, relevant_experience: v === "" ? null : v })); }}
                                    placeholder="e.g. 2.0"
                                />
                                {candidateData.relevant_experience && candidateData.total_work_exp && parseFloat(candidateData.relevant_experience) > parseFloat(candidateData.total_work_exp) && (
                                    <span style={{ color: T.red, fontSize: 12, marginTop: 4, display: "block" }}>Cannot exceed total work experience ({candidateData.total_work_exp} yrs)</span>
                                )}
                            </div>
                        </div>

                        <div style={S.row}>
                            <SkillPair skillKey="skill1" expKey="exp1" label="Skill 1" required disabled={false}
                                data={data} filterList={filterList} onSkillSearch={onSkillSearch}
                                skillUpdate={skillUpdate} expUpdate={expUpdate} totalWorkExp={candidateData.total_work_exp} />
                            <SkillPair skillKey="skill2" expKey="exp2" label="Skill 2" disabled={!data.skill1}
                                data={data} filterList={filterList} onSkillSearch={onSkillSearch}
                                skillUpdate={skillUpdate} expUpdate={expUpdate} totalWorkExp={candidateData.total_work_exp} />
                            <SkillPair skillKey="skill3" expKey="exp3" label="Skill 3" disabled={!data.skill2}
                                data={data} filterList={filterList} onSkillSearch={onSkillSearch}
                                skillUpdate={skillUpdate} expUpdate={expUpdate} totalWorkExp={candidateData.total_work_exp} />
                            <SkillPair skillKey="skill4" expKey="exp4" label="Skill 4" disabled={!data.skill3}
                                data={data} filterList={filterList} onSkillSearch={onSkillSearch}
                                skillUpdate={skillUpdate} expUpdate={expUpdate} totalWorkExp={candidateData.total_work_exp} />
                            <SkillPair skillKey="skill5" expKey="exp5" label="Skill 5" disabled={!data.skill4}
                                data={data} filterList={filterList} onSkillSearch={onSkillSearch}
                                skillUpdate={skillUpdate} expUpdate={expUpdate} totalWorkExp={candidateData.total_work_exp} />

                            <div style={{
                                ...S.col3,
                                opacity: ['skill1', 'skill2', 'skill3', 'skill4', 'skill5'].every(k => data[k]) ? 1 : 0.4,
                                pointerEvents: ['skill1', 'skill2', 'skill3', 'skill4', 'skill5'].every(k => data[k]) ? 'auto' : 'none',
                            }}>
                                <Label>Other Skills</Label>
                                <Styled.AutosearchDiv>
                                    <AutoSearchBox
                                        onSearch={(fn, val) => debouncedSearch(fn, val)}
                                        fieldName="otherSkills_all"
                                        options={otherSkillCandidateOptions}
                                        selectedValues={data.otherSkills}
                                        setSelectedValues={otherSkillsUpdate}
                                        placeholder="Fill all 5 skills first"
                                    />
                                </Styled.AutosearchDiv>
                            </div>
                        </div>
                        {errorMessage && <p style={{ color: T.red, fontSize: 13, marginTop: 8 }}>{errorMessage}</p>}
                    </div>

                    {/* ════ EMPLOYMENT DETAILS ════ */}
                    <div style={{ ...S.card, opacity: checkClicked ? 1 : 0.5, pointerEvents: checkClicked ? "auto" : "none", transition: "opacity 0.2s" }}>
                        <p style={S.cardTitle}>Employment Details</p>
                        <div style={S.row}>
                            <div style={S.col4}>
                                <Label required>Current CTC</Label>
                                <div style={S.ctcWrap}><input style={S.ctcInput} value={candidateData.current_ctc || ""} onChange={e => handleCtcChange('current_ctc', e.target.value)} placeholder="e.g. 8.5" /><span style={S.ctcUnit}>LPA</span></div>
                            </div>
                            <div style={S.col4}>
                                <Label required>Expected CTC</Label>
                                <div style={S.ctcWrap}><input style={S.ctcInput} value={candidateData.expected_ctc || ""} onChange={e => handleCtcChange('expected_ctc', e.target.value)} placeholder="e.g. 12.0" /><span style={S.ctcUnit}>LPA</span></div>
                            </div>
                            <div style={S.col4}>
                                <Label>Variable CTC</Label>
                                <div style={{ ...S.ctcWrap, borderColor: (!isVariableCtcValid()) ? T.red : T.border }}>
                                    <input style={S.ctcInput} type="text" value={candidateData.variables || ""} onChange={e => handleCtcChange('variables', e.target.value)} placeholder="Variable pay" />
                                    <span style={S.ctcUnit}>LPA</span>
                                </div>
                                {!isVariableCtcValid() && <span style={{ color: T.red, fontSize: 12, marginTop: 4, display: "block" }}>Must be less than current CTC ({candidateData.current_ctc} LPA)</span>}
                            </div>
                            <div style={S.col4}>
                                <Label>Stock Options</Label>
                                <div style={S.ctcWrap}>
                                    <input style={S.ctcInput} type="text" value={candidateData.stock_opt || ""} onChange={e => { const v = e.target.value; if (/^\d*$/.test(v) || v === "") setCandidateData(prev => ({ ...prev, stock_opt: v === "" ? null : parseInt(v) })); }} placeholder="Amount" />
                                    <span style={S.ctcUnit}>INR</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ════ LOCATION DETAILS ════ */}
                    <div style={{ ...S.card, opacity: checkClicked ? 1 : 0.5, pointerEvents: checkClicked ? "auto" : "none", transition: "opacity 0.2s" }}>
                        <p style={S.cardTitle}>Location Details</p>
                        <div style={S.row}>
                            <div style={S.col2}>
                                <Label required>Current Location</Label>
                                <Select style={S.select} showSearch placeholder="Select city"
                                    onSearch={e => setFilterCurrentLocation(locationOption.filter(i => i.key.toLowerCase().includes(e.toLowerCase())))}
                                    value={candidateData.candidate_location}
                                    onChange={e => setCandidateData(prev => ({ ...prev, candidate_location: e }))}>
                                    {filterCurrentLocationOption.map(i => <Select.Option key={i.key} value={i.key}>{i.value}</Select.Option>)}
                                </Select>
                            </div>
                            <div style={S.col2}>
                                <Label required>Preferred Location</Label>
                                <Styled.AutosearchDiv>
                                    <AutoSearchBox
                                        onSearch={(fn, val) => setFilterLocationOption(locationOption.filter(i => i.key.toLowerCase().includes(val.toLowerCase())))}
                                        options={filterLocationOption} fieldName="location"
                                        selectedValues={candidateData.candidate_prefered_location}
                                        setSelectedValues={loc => setCandidateData(prev => ({ ...prev, candidate_prefered_location: loc }))}
                                        placeholder="Select city"
                                    />
                                </Styled.AutosearchDiv>
                            </div>
                        </div>
                    </div>

                    {/* ════ NOTICE PERIOD DETAILS ════ */}
                    <div style={{ ...S.card, opacity: checkClicked ? 1 : 0.5, pointerEvents: checkClicked ? "auto" : "none", transition: "opacity 0.2s" }}>
                        <p style={S.cardTitle}>Notice Period Details</p>
                        <div style={S.row}>
                            <div style={S.col4}>
                                <Label required>Notice Period Status</Label>
                                <div style={{ ...S.radioWrap, marginTop: 14, flexDirection: "column", alignItems: "flex-start", gap: 12 }}>
                                    <label style={S.radioLabel}>
                                        <input type="radio" name="Serving"
                                            checked={candidateData.currently_serving === true && candidateData.notice_status === 'Served'}
                                            onChange={() => setCandidateData(prev => ({ ...prev, currently_serving: true, notice_status: 'Served', notice_period: null, negotiable: null, buy_out_available: null, shortest_notice_period: null, immediate_joining: false }))} />
                                        Served
                                    </label>
                                    <label style={S.radioLabel}>
                                        <input type="radio" name="Serving"
                                            checked={candidateData.currently_serving === true && candidateData.notice_status === 'Serving'}
                                            onChange={() => setCandidateData(prev => ({ ...prev, currently_serving: true, notice_status: 'Serving', notice_period: null, negotiable: null, buy_out_available: null, shortest_notice_period: null, immediate_joining: false }))} />
                                        Serving
                                    </label>
                                    <label style={S.radioLabel}>
                                        <input type="radio" name="Serving"
                                            checked={candidateData.currently_serving === false}
                                            onChange={() => setCandidateData(prev => ({ ...prev, currently_serving: false, notice_status: 'Not Serving', last_working_day: null, available_from: null }))} />
                                        Not Serving
                                    </label>
                                </div>
                            </div>

                            {candidateData.currently_serving === true && (
                                <>
                                    <div style={S.col4}>
                                        <Label required>Last Working Day</Label>
                                        <DatePicker style={{ width: "100%", height: T.inputH }}
                                            value={candidateData.last_working_day ? dayjs(candidateData.last_working_day) : null}
                                            onChange={(_, ds) => setCandidateData(prev => ({ ...prev, last_working_day: dayjs(ds).utc().format() }))} />
                                    </div>
                                    <div style={S.col4}>
                                        <Label required>Date Available From</Label>
                                        <DatePicker style={{ width: "100%", height: T.inputH }}
                                            value={candidateData.available_from ? dayjs(candidateData.available_from) : null}
                                            onChange={(_, ds) => setCandidateData(prev => ({ ...prev, available_from: dayjs(ds).utc().format() }))} />
                                    </div>
                                </>
                            )}

                            {candidateData.currently_serving === false && (
                                <>
                                    <div style={{ flex: "1 1 calc(50% - 10px)", minWidth: 200, marginBottom: 20 }}>
                                        <Label required>Notice Period</Label>
                                        <div style={{ ...S.ctcWrap, background: candidateData.immediate_joining ? "#f5f5f5" : T.white }}>
                                            <input
                                                style={{ ...S.ctcInput, color: candidateData.immediate_joining ? "#bbb" : T.text, cursor: candidateData.immediate_joining ? "not-allowed" : "text" }}
                                                type="text"
                                                value={candidateData.immediate_joining ? "" : (candidateData.notice_period || "")}
                                                readOnly={candidateData.immediate_joining}
                                                onChange={e => { if (candidateData.immediate_joining) return; const v = e.target.value; if (/^\d*$/.test(v) || v === "") setCandidateData(prev => ({ ...prev, notice_period: v === "" ? null : v })); }}
                                                placeholder="e.g. 30"
                                            />
                                            <span style={S.ctcUnit}>Days</span>
                                        </div>
                                        <div style={{ display: "flex", gap: 16, marginTop: 10, flexWrap: "wrap" }}>
                                            <Checkbox checked={candidateData.immediate_joining === true}
                                                onChange={e => setCandidateData(prev => ({ ...prev, immediate_joining: e.target.checked, notice_period: e.target.checked ? null : prev.notice_period, negotiable: e.target.checked ? false : prev.negotiable, shortest_notice_period: e.target.checked ? null : prev.shortest_notice_period }))}>
                                                Immediate
                                            </Checkbox>
                                            <Checkbox checked={candidateData.negotiable === true} disabled={candidateData.immediate_joining === true}
                                                onChange={e => setCandidateData(prev => ({ ...prev, negotiable: e.target.checked, shortest_notice_period: e.target.checked ? prev.shortest_notice_period : null }))}>
                                                Negotiable
                                            </Checkbox>
                                            <Checkbox checked={candidateData.buy_out_available === true}
                                                onChange={e => setCandidateData(prev => ({ ...prev, buy_out_available: e.target.checked }))}>
                                                Buy out available
                                            </Checkbox>
                                        </div>
                                    </div>

                                    {candidateData.negotiable && !candidateData.immediate_joining && (
                                        <div style={{ flex: "0 0 auto", width: 220, marginBottom: 20 }}>
                                            <Label required>Shortest Notice Period</Label>
                                            <div style={{ ...S.ctcWrap, borderColor: (candidateData.shortest_notice_period && candidateData.notice_period && parseInt(candidateData.shortest_notice_period) >= parseInt(candidateData.notice_period)) ? T.red : T.border }}>
                                                <input style={S.ctcInput} type="text" value={candidateData.shortest_notice_period || ""}
                                                    onChange={e => { const v = e.target.value; if (/^\d{0,3}$/.test(v)) setCandidateData(prev => ({ ...prev, shortest_notice_period: v === "" ? null : parseInt(v) })); }}
                                                    placeholder="No. of days" />
                                                <span style={S.ctcUnit}>Days</span>
                                            </div>
                                            {candidateData.shortest_notice_period && candidateData.notice_period && parseInt(candidateData.shortest_notice_period) >= parseInt(candidateData.notice_period) && (
                                                <span style={{ color: T.red, fontSize: 12, marginTop: 4, display: "block" }}>Must be less than notice period ({candidateData.notice_period} days)</span>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        <div style={{ marginTop: 8 }}>
                            <Label required>Offer in Hand?</Label>
                            <div style={S.radioWrap}>
                                <label style={S.radioLabel}><input type="radio" name="offer" checked={candidateData.offer_in_hand === true} onChange={() => setCandidateData(prev => ({ ...prev, offer_in_hand: true }))} />Yes</label>
                                <label style={S.radioLabel}><input type="radio" name="offer" checked={candidateData.offer_in_hand === false} onChange={() => setCandidateData(prev => ({ ...prev, offer_in_hand: false }))} />No</label>
                            </div>
                        </div>

                        {candidateData.offer_in_hand && (
                            <div style={{ ...S.row, marginTop: 16 }}>
                                <div style={S.col2}>
                                    <Label required>Offered CTC</Label>
                                    <div style={S.ctcWrap}><input style={S.ctcInput} type="text" value={candidateData.offered_ctc || ""} onChange={e => handleCtcChange('offered_ctc', e.target.value)} placeholder="Amount" /><span style={S.ctcUnit}>LPA</span></div>
                                </div>
                                <div style={S.col2}>
                                    <Label required>Joining Date of Offer</Label>
                                    <DatePicker style={{ width: "100%", height: T.inputH }}
                                        value={candidateData.joining_date_of_offer ? dayjs(candidateData.joining_date_of_offer) : null}
                                        onChange={(_, ds) => setCandidateData(prev => ({ ...prev, joining_date_of_offer: dayjs(ds).utc().format() }))} />
                                </div>
                            </div>
                        )}
                    </div>

                    {/* ════ ROLE SPECIFIC REQUIREMENTS ════ */}
                    {roleQuestions && (
                        <div style={{ ...S.card, opacity: checkClicked ? 1 : 0.5, pointerEvents: checkClicked ? "auto" : "none", transition: "opacity 0.2s" }}>
                            <p style={S.cardTitle}>Role Specific Requirements</p>
                            <div style={S.row}>
                                {[1, 2, 3, 4, 5].map(n => {
                                    const q = roleQuestions[`question${n}`];
                                    if (!q) return null;
                                    return (
                                        <div key={n} style={S.col2}>
                                            <Label required>{q.question}</Label>
                                            <textarea style={S.textarea} value={data[`response${n}`] || ""} onChange={e => responseUpdate(`question${n}`, `response${n}`, e.target.value)} placeholder="Candidate's answer" />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* ════ OTHER DETAILS ════ */}
                    <div style={{ ...S.card, opacity: checkClicked ? 1 : 0.5, pointerEvents: checkClicked ? "auto" : "none", transition: "opacity 0.2s" }}>
                        <p style={S.cardTitle}>Other Details</p>
                        <div style={S.row}>
                            <div style={S.col3}>
                                <Label required>Fitment Score</Label>
                                <div style={S.ctcWrap}>
                                    <input
                                        style={S.ctcInput}
                                        type="text"
                                        value={callDetails.fitment_score ?? ""}
                                        onChange={e => {
                                            const v = e.target.value;
                                            if (v === "" || (/^\d+$/.test(v) && Number(v) >= 0 && Number(v) <= 100)) {
                                                setCallDetails(prev => ({ ...prev, fitment_score: v === "" ? null : Number(v) }));
                                            }
                                        }}
                                        placeholder="0 – 100"
                                    />
                                    <span style={S.ctcUnit}>%</span>
                                </div>
                            </div>
                            <div style={S.col3}>
                                <Label required>Assessment Schedule Date &amp; Time</Label>
                                <DatePicker showTime={{ format: "HH:mm", showSecond: false, minuteStep: 5 }} format="DD-MM-YYYY HH:mm"
                                    style={{ width: "100%", height: T.inputH }}
                                    value={callDetails.assessment_schedule_datetime ? dayjs(callDetails.assessment_schedule_datetime) : null}
                                    onChange={(date) => setCallDetails(prev => ({ ...prev, assessment_schedule_datetime: date ? date.utc().format() : null }))} />
                            </div>
                            <div style={S.col3}>
                                <Label required>CV Source</Label>
                                <Select style={S.select} placeholder="Select source" value={candidateData?.cv_source} onChange={e => setCandidateData(prev => ({ ...prev, cv_source: e }))}>
                                    {cvsourceList.map(item => <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)}
                                </Select>
                            </div>
                        </div>
                        <div style={{ marginBottom: 20 }}>
                            <Label>Remarks</Label>
                            <textarea style={S.textarea} value={callDetails.remarks} onChange={e => setCallDetails(prev => ({ ...prev, remarks: e.target.value }))} placeholder="Add any notes about this call..." />
                        </div>
                    </div>

                    {error && <p style={{ color: T.red, marginTop: 12, fontSize: 14, fontWeight: 600 }}>{error}</p>}

                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
                        <Styled.SearchButton onClick={handleSubmitClick}>Submit Form</Styled.SearchButton>
                    </div>

                </div>
            </Styled.ContentWrapDiv>

            {/* ════ SUBMISSION CONFIRMATION POPUP ════ */}
            <Modal
                open={confirmOpen}
                title={
                    <div style={{ fontSize: "18px", fontWeight: 600 }}>
                        Confirm Submission
                    </div>
                }
                onCancel={() => setConfirmOpen(false)}
                centered
                style={{ marginLeft: 160 }}
                footer={[
                    <Button
                        key="no"
                        onClick={() => setConfirmOpen(false)}
                        style={{
                            minWidth: 80,
                            borderRadius: 6,
                        }}
                    >
                        No
                    </Button>,
                    <Button
                        key="yes"
                        type="primary"
                        onClick={() => {
                            setConfirmOpen(false);
                            doSubmit();
                        }}
                        style={{
                            minWidth: 110,
                            borderRadius: 6,
                            fontWeight: 500,
                        }}
                    >
                        Yes, Submit
                    </Button>,
                ]}
            >
                <div
                    style={{
                        padding: "8px 2px 4px",
                        color: "#4B5563",
                        fontSize: "14px",
                        lineHeight: 1.7,
                    }}
                >
                    <p style={{ margin: "0 0 8px" }}>
                        Please confirm that all candidate details have been filled in
                        correctly.
                    </p>

                    <p style={{ margin: 0, fontWeight: 500, color: "#1F2937" }}>
                        Do you want to proceed with the submission?
                    </p>
                </div>
            </Modal>
        </Styled.MainContainer>
    );
};

export default CallerForm;